import { EinreichungStep } from '@ebeihilfe/einreichung-old';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'asMainStep',
  standalone: true,
})
export class AsMainStepPipe implements PipeTransform {
  public transform(currentStep: EinreichungStep): number {
    switch (true) {
      case currentStep < EinreichungStep.MAIN:
        return EinreichungStep.INIT;
      case currentStep < EinreichungStep.UPLOADING:
        return EinreichungStep.MAIN;
      case currentStep < EinreichungStep.COMPLETE:
        return EinreichungStep.UPLOADING;
      default:
        return EinreichungStep.COMPLETE;
    }
  }
}
